<template>
    <!-- One role sheet seat in a popup (My Role, View Role, the accountability chart). slug + colID = the sheet
         and seat (tblEmployee.RoleSheetSlug / RoleSheetColID); signing signs that seat of that sheet -->
    <div class="error-msg-wrap">
        <div v-if="showColSignOff" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="() => { showColSignOff = false }">&times;</button>
            </div>
            <div style="height: 100px;border-bottom:1px solid black;margin:0 10px 10px"><VueSignaturePad ref="signOffPad" /></div>
            <div style="padding: 0 10px 10px"><b>Sign Name Above</b> - <a @click.prevent="() => { ($refs as any).signOffPad.clearSignature() }">Clear</a></div>
            <input style="margin-top:15px" type="text" placeholder="Type your name" v-model="colSignOffInput" />
            <input :class="colSignOffSubmitting ? 'disable-button' : ''" type="submit" value="Submit" @click="submitColSignOff()" />
        </div>
        <div v-else-if="found" class="form-wrapper slide-up rv rv-modal">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <header class="rv-seathead">
                <span class="rv-big">{{ initials }}</span>
                <div class="rv-seathead-t">
                    <div class="rv-sn">{{ seat.name || seat.title || 'Role' }}</div>
                    <div v-if="seat.name && seat.title" class="rv-st">{{ seat.title }}</div>
                    <div class="rv-from">{{ found.node.Name }}</div>
                </div>
            </header>
            <div class="rv-actions">
                <button type="button" class="btn rv-act" @click="showColSignOff = true"><svg viewBox="0 0 24 24"><path d="M3 17c3.33-3.33 5-6 5-8a3 3 0 0 0-6 0c0 3 3 4.5 4.5 6.5C7.5 16.8 8.3 18 9 18c1.5 0 2.5-3 3-3s1 2 2.5 2c.6 0 1.6-.6 2.5-2M17 20h4" /></svg>Sign off</button>
                <button type="button" class="ep-chip" @click="goToRoleSheet()"><svg viewBox="0 0 24 24"><path d="M12 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6M11 13l9-9M15 4h5v5" /></svg>Open role sheet</button>
            </div>
            <role-seat :accountabilities="found.seat.accountabilities" :sections="sections" prefix="role-col" />
            <p v-if="!sections.length && !found.seat.accountabilities.length" class="rv-empty">This role hasn't been filled in yet.</p>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import RoleSeat from '@/components/RoleSeat.vue';
import { findSeat, seatSections, seatSnapshot, seatInitials, seatNameTitle } from '@/roleSheet';

export default defineComponent({
    name: 'TeamHubRoleCol',
    props: [ 'slug', 'colID' ],
    emits: [ 'close' ],
    components: {
        RoleSeat
    },
    data() {
        return {
            found: null as any,
            showColSignOff: false,
            colSignOffSubmitting: false,
            colSignOffInput: ''
        }
    },
    computed: {
        sections(): any[] {
            return this.found ? seatSections(this.found.sheet, this.found.seat) : [];
        },
        seat(): { name: string, title: string } {
            return seatNameTitle(this.found?.seat);
        },
        initials(): string {
            return seatInitials(this.found?.seat);
        }
    },
    created() {
        this.found = findSeat(this.$store.state.allNodes, this.slug, this.colID);
        if(!this.found) {
            alert('Role not found');
            this.$emit('close');
        }
    },
    methods: {
        async submitColSignOff() {
            if(!this.colSignOffInput) {
                alert('Type your name');
                return;
            }

            const { isEmpty, data } = (this.$refs as any).signOffPad.saveSignature();
            if(isEmpty) {
                alert('Include written signature');
                return;
            }

            this.colSignOffSubmitting = true;

            // The sheet and seat shown here (not necessarily the signed-in employee's own role)
            const formData = {
                cells: JSON.stringify(seatSnapshot(this.found.sheet, this.found.seat.id)),
                signature: this.colSignOffInput,
                slug: this.found.node.Slug,
                nodeName: this.found.node.Name,
                signatureData: data
            }

            await axios.post(`${this.$store.state.apiUrl}/api/signoffs`, formData)
                .then(() => {
                    alert('Sign off submitted!');
                    this.colSignOffInput = '';
                    this.showColSignOff = false;
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error');
                })

            this.colSignOffSubmitting = false;
        },
        goToRoleSheet() {
            this.$emit('close');
            this.$router.push(`/playbook/${this.found.node.Slug}?col=${this.found.seat.id}`);
        }
    }
});
</script>
